export class Profile {
    public userId: number;
    public isTrader: boolean;
    public profileInfo: ProfileInfo; 
    public dateFirstOperation?: Date; 
    public dateLastOperation?: Date; 
    public contractCurrentMonth: number; 
    public contractLastMonth: number; 
    public platforms: Array<string>;
    public clubTrader: ClubTrader;
    constructor() {
        this.userId = 0;
        this.isTrader = false;
        this.profileInfo = new ProfileInfo();
        this.dateFirstOperation = undefined;
        this.dateLastOperation = undefined;
        this.contractCurrentMonth = 0;
        this.contractLastMonth = 0;
        this.platforms = [];
        this.clubTrader = new ClubTrader();
    }
}

export class ProfileInfo {
    typeProfile: string;
    dateEntry?: Date;
    dateDue?: Date;
}

export class ClubTrader {
    starter: {
        minimum: number;
        maximum: number;
    };
    master: {
        minimum: number;
        maximum: number;
    };
    vip: {
        minimum: number;
        maximum?: number;
    }
}